import React from 'react';
import { FlaskConicalIcon } from 'lucide-react';

/**
 * Etiqueta visible en todas las pantallas que muestran datos de ejemplo.
 * Desaparecerá al conectar Supabase y vaciar el store de demostración.
 */
export function DemoBadge({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary ${className}`} data-id="element-98" data-mp="3ii2xxo2md28p">
      <FlaskConicalIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-99" data-mp="2kw5m29iqvv5q" />
      Datos de demostración
    </span>;
}